import ServicePage from "@/components/ServicePage";

export default function CarTransport() {
  return (
    <ServicePage
      slug="car-transport"
      testid="page-car-transport"
      title="Car Transport UK | Instant Online Quote | MHJ Prestige Transport"
      metaDescription="Professional door-to-door car transport across the UK. Get an instant online quote in under 60 seconds and book your collection with MHJ Prestige Transport."
      h1="Professional car transport across the UK"
      intro="From daily drivers to prestige and classic cars — we move vehicles safely, on time, and with a transparent instant online quote. Book collection in minutes."
      heroImage="https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/3n3iv3ni_Screenshot_20260609_112234_Gallery.jpg"
      bullets={[
        "Instant online quote — no phone tag, price shown before you book",
        "Door-to-door collection and delivery",
        "Enclosed and open transporters, soft-strap tie-downs",
        "Fully insured — goods-in-transit and public liability",
        "Photos at collection and delivery for peace of mind",
        "Secure Stripe deposit (30%) — balance on delivery",
      ]}
      sections={[
        {
          title: "How our car transport service works",
          body: (
            <>
              <p>
                Enter your collection and delivery postcodes, tell us a bit about the vehicle, and
                pick a date. Our pricing engine returns a firm quote instantly — the same figure
                you&rsquo;d be given on the phone, just without the wait.
              </p>
              <p>
                Once you&rsquo;re happy, secure your slot with a small deposit through Stripe. We&rsquo;ll
                confirm your driver and give you tracking updates on collection day. Balance is
                due on delivery.
              </p>
            </>
          ),
        },
        {
          title: "Who we move cars for",
          body: (
            <ul className="list-disc pl-6 space-y-1.5">
              <li>Private buyers and sellers moving cars nationwide</li>
              <li>Dealerships and traders moving stock between forecourts</li>
              <li>Auction house collections (Copart, IAAI, Manheim and more)</li>
              <li>Classic and prestige owners who need soft-strap, enclosed transport</li>
              <li>Insurance claimants who need accident recovery and onward transport</li>
            </ul>
          ),
        },
      ]}
      faq={[
        {
          q: "How much does UK car transport cost?",
          a: "Prices depend on distance, vehicle size, condition and how quickly you need collection. Our instant online quote gives you a firm figure in under a minute — no obligation.",
        },
        {
          q: "Do I have to pay in full up front?",
          a: "No. We take a secure 30% deposit via Stripe to reserve the slot. The remaining balance is paid on delivery.",
        },
        {
          q: "Do you transport non-runners?",
          a: "Yes — see our non-runner transport page. Winch-loading is included in the quote where applicable.",
        },
        {
          q: "Are the vehicles insured while in your care?",
          a: "Yes, we hold current goods-in-transit and public liability cover. Documentation is available on request.",
        },
      ]}
    />
  );
}
